import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../../../config/i18n';
import ReviewTravelDates from './ReviewTravelDates';

import './review_confirmation.css';

const ratingFields = [
  { propertyName: 'ratingArea', translationKey: 'area' },
  { propertyName: 'ratingComfort', translationKey: 'comfort' },
  { propertyName: 'ratingValue', translationKey: 'value' },
  { propertyName: 'ratingCleanliness', translationKey: 'cleanliness' },
];

export default function ReviewConfirmation({
  lang,
  invitationCode,
  booking,
  ratings,
  reviewText,
  npsScore,
  onCorrectReview,
  handleReviewSubmit,
}) {
  if (!booking || !ratings) {
    return <div>something went wrong</div>;
  }

  function handleSubmit() {
    handleReviewSubmit(lang, invitationCode, ratings, reviewText, npsScore);
  }

  function handleCancel() {
    onCorrectReview();
  }

  return (
    <div>
      <p>{I18n.t('reviews.confirmation_intro')}</p>
      <ReviewTravelDates booking={booking} />
      <div className="reviews__question">{I18n.t('reviews.rating_headline')}</div>
      <div className="reviewconfirmation__rating-summary reviewconfirmation__userinput">
        {ratingFields.map((field) => (
          <div key={field.translationKey} className="reviewconfirmation__rating-field">
            <div className="reviewconfirmation__rating-label">
              <i>{I18n.t(`reviews.question_${field.translationKey}`)}</i>
            </div>
            <div className="reviewconfirmation__rating-value">
              {I18n.t(`reviews.rating_selection_${ratings[field.propertyName]}`)}
            </div>
          </div>
        ))}
      </div>
      <div className="reviews__question reviews__question--non-top">
        {I18n.t('reviews.review_headline')}
      </div>
      <div className="reviewconfirmation__review-text reviewconfirmation__userinput">
        {reviewText}
      </div>
      <div className="reviews__question reviews__question--non-top">
        {I18n.t('reviews.nps_headline')}
      </div>
      <div className="reviewconfirmation__npsScore reviewconfirmation__userinput">
        {npsScore}/10
      </div>
      <div className="reviewconfirmation__submitrow">
        <button type="button" className="reviewconfirmation__cancelbutton" onClick={handleCancel}>
          {I18n.t('reviews.cancel_correct')}
        </button>
        <button type="submit" className="reviews__submitbutton" onClick={handleSubmit}>
          {I18n.t('reviews.submit')}
        </button>
      </div>
    </div>
  );
}

ReviewConfirmation.propTypes = {
  lang: PropTypes.string.isRequired,
  invitationCode: PropTypes.string.isRequired,
  booking: PropTypes.shape({
    accommodationTitle: PropTypes.string,
    arrival: PropTypes.instanceOf(Date),
    departure: PropTypes.instanceOf(Date),
    firstName: PropTypes.string,
  }).isRequired,
  ratings: PropTypes.shape({
    ratingArea: PropTypes.number.isRequired,
    ratingComfort: PropTypes.number.isRequired,
    ratingValue: PropTypes.number.isRequired,
    ratingCleanliness: PropTypes.number.isRequired,
  }).isRequired,
  reviewText: PropTypes.string.isRequired,
  npsScore: PropTypes.number.isRequired,
  onCorrectReview: PropTypes.func.isRequired,
  handleReviewSubmit: PropTypes.func.isRequired,
};
